const reason: {
  [identifer: string]: string;
} = {
  country: 'country',
  state: 'state',
  city: 'city',
  location: 'location',
};
  
export default reason;
  
